export enum LSE_ACTIONS {
    UPDATE = 'update',
    CREATE = 'create',
    DISABLE = 'disable',
  }